/**
 * Entry point — initializes MSAL then mounts the React app.
 *
 * MSAL v3 requires `instance.initialize()` to complete before any
 * React rendering so that the redirect response (if one is in-flight)
 * is handled before AuthGuard evaluates the account state.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { msalInstance } from './lib/msal';
import './styles/theme.css';
import './styles/app.css';
import './styles/home.css';
import './styles/taps.css';
import './styles/tasks.css';
import './styles/supplies.css';
import './styles/admin.css';
import './styles/bartenders.css';
import 'react-day-picker/style.css';
import './styles/events.css';
import './styles/canto.css';
import './styles/touch.css';

async function bootstrap(): Promise<void> {
  // Initialize MSAL. This processes any redirect response that may be
  // sitting in the URL/session before the React tree mounts, preventing
  // a flash of the "unauthenticated" screen on sign-in return.
  await msalInstance.initialize();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

bootstrap().catch((err) => {
  console.error('MSAL bootstrap failed:', err);
  // Still mount the app so the user can see an error rather than a blank page.
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
